import type { Category } from "./types.js";

export interface CategoryInfo {
  key: Category;
  /** User-facing label (European Portuguese). */
  label: string;
  /** Emoji shown on timeline markers and in the form. */
  icon: string;
  /** Accent colour for this category (used on cards/markers). */
  color: string;
}

/** Metadata for each milestone category — single source of truth for labels + icons. */
export const CATEGORIES: Record<Category, CategoryInfo> = {
  primeiros: { key: "primeiros", label: "Primeiros", icon: "💌", color: "#e8b4a0" },
  viagem: { key: "viagem", label: "Viagens", icon: "✈️", color: "#8fb8c9" },
  conquista: { key: "conquista", label: "Conquistas", icon: "🏆", color: "#c9a227" },
  data: { key: "data", label: "Datas especiais", icon: "🎉", color: "#d98c9a" },
  momento: { key: "momento", label: "Momentos", icon: "🌟", color: "#e6ce84" },
};

/** Ordered list, handy for selects and legends. */
export const CATEGORY_LIST: CategoryInfo[] = Object.values(CATEGORIES);

export function categoryInfo(category: Category): CategoryInfo {
  return CATEGORIES[category];
}
